<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="5" right>在這裡，是一封信，我沒看過內容。</npc>
              <npc :npc-id="0">謝謝你。</npc>
              <npc :npc-id="1">快打開看看吧！</npc>

              <div class="bg-white text-dark py-4 px-3 mb-4">
                文學偵探們敬啟<br/>
                <br/>
                如果你們看到這封信，我大概已經跟時間警察在時空迷宮同歸於盡了，但不必為我傷心煩惱，這是我應得的報應。<br/>
                <br/>
                我是〈善訟的人的故事〉裡的林先生。老實說，發現自己是小說人物時，我花了很多時間來接受；不過，就算我不是真實的，既然我存在於此，我的故鄉就一定存在！因此我希望至少在〈善訟的人的故事〉裡，「林先生」沒有失蹤，最後回到家鄉去了。<br/>
                <br/>
                我追隨許多賴和先生的研究，知道「發現賴和」是始於賴和先生的手稿被發掘出來，而且手稿裡有很多內容，跟發表或出版的內容有出入。既然如此，〈善訟的人的故事〉是不是也可以有另一個版本？所以我絞盡腦汁，利用自己的能力回到「發現賴和」前，偷走手稿，但我抵達的時間太不巧，居然就是賴和先生的家人決定交出手稿的時間，本來要交出的手稿消失了，對賴和先生的研究受挫，於是出現了另一個時空，而且越來越穩定，很可能吞噬我們原本的時空。<br/>
                <br/>
                這都是我的錯，我有義務修正，這個新的時空有時間警察，他們會阻止我修復時空，我與他們交手過幾次，知道他們非常難纏，我往未來移動，終於找到能將他們困住的裝置——時空迷宮——但只是一時的，除非有人不斷阻止時間警察。那時，我就下了決心。<br/>
                <br/>
                把你們捲進來，我很慚愧，但要是原始時空消失，文學偵探也將不再存在；我偷走賴和面具，讓文學館委託你們，接著設下陷阱，把你們拉到這個即將穩定的時空，引導你們協助我在時空中反覆移動，直到我再度抵達1984年。請放心，為避免節外生枝，我沒有修改手稿，一切都將如最初。要是你們能看到這封信，就表示我已盡完自己的義務，正如當初我為了彰化的鄉親到福州請願，不管有多危險，我會做好自己該做的事。<br/>
                <br/>
                請容我再度致歉，並讓我感謝，感謝你們「再度發現賴和」。 
              </div>

              <npc :npc-id="1" right>⋯⋯嚇死我，原來差一點點，我們就要消失了啊！</npc>
              <npc :npc-id="0">是啊。雖然應該沒事了，但一想到林先生為了拯救這個時空，必須永遠跟時間警察奮鬥下去⋯⋯唉，我們所享有的這個時空並不是理所當然，而是有人默默努力支撐下來的呢。</npc>
              <npc :npc-id="1" right>對啊。不過這次呂善安真沒用，根本只是跟著林先生的計畫走，連面具都是他自己還給你的。</npc>
              <npc :npc-id="0">哎呀，我姑且也對『證明』有所貢獻好嗎？不過，還真是趟奇幻的旅程。</npc>
              <npc :npc-id="1" right>怎麼說？</npc>
              <npc :npc-id="0">就像林先生說的一樣啊，雖然以文學史的角度來看不值一提，但追究跟賴和先生有關的地景，確實就是一次『再發現』啊！</npc>
              <npc :npc-id="1" right>這麼說好像也沒錯。</npc>
              <npc :npc-id="0">好了，我要跟臺灣文學館回報面具的事了⋯⋯小蘇。</npc>
              <npc :npc-id="1" right>嗯？</npc>
              <npc :npc-id="0">你是第一次來賴和紀念館吧？何不趁這機會好好看看呢？賴和先生的事蹟，可遠遠不止我們這次旅程中的再發現喔——</npc>

              <p class="text-center font-weight-bold" style="font-size: 3rem">The End</p>

              <story-image :src="require(`@/assets/images/pics/第8章_4-3_賴和館4樓.jpg`)" size="lg"></story-image>
              <!-- （圖片：賴和紀念館的內部照片） -->

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage8_no',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '終章 - 1',
      isQuestion: false,
      stageId: 'normal',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
